module.exports = __webpack_public_path__ + "assets/emblem_bbyo.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/emblem_bbyo.png
 ** module id = 112
 ** module chunks = 1
 **/